'use client';

import { User } from 'lucide-react';
import Link from 'next/link';
import { useAuth } from '@/app/context/AuthContext';
import CartIcon from './CartIcon';

export default function ProductsNavbar() {
  const { user, loading: authLoading } = useAuth();

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">

          <Link href="/" className="flex items-center gap-2 group min-h-11">
            <span className="font-bold text-lg sm:text-xl text-gray-900 group-hover:text-[#23994F] transition-colors">VERPHONE</span>
          </Link>


          <div className="flex items-center gap-3">
            {!authLoading && (
              <>
                {user ? (
                  <>

                    <CartIcon />


                    <Link
                      href="/account"
                      className="flex items-center gap-2 px-3 sm:px-4 py-2 min-h-11 bg-gray-100 text-gray-700 font-semibold text-sm rounded-lg hover:bg-gray-200 transition-all duration-300"
                    >
                      <User size={18} />
                      <span className="hidden sm:inline">Mon compte</span>
                    </Link>
                  </>
                ) : (
                  <Link
                    href="/login"
                    className="px-4 sm:px-5 py-2 min-h-11 bg-[#23994F] text-white font-semibold text-sm sm:text-base rounded-lg hover:bg-[#1a7840] transition-all duration-300 hover:shadow-lg"
                  >
                    Se connecter
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
